import React from 'react'

import { Skeleton } from '@fourthwall/components'

export const CustomEmojiSkeleton = () => (
  <Skeleton gap={16}>
    <Skeleton.Shape width="100%" height={33} />
    <Skeleton.Shape width="100%" height={72} />
    <Skeleton.Shape width="100%" height={40} />
    <Skeleton.Shape width="100%" height={140} />
  </Skeleton>
)
